import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-earth-brown text-earth-beige">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-earth-beige rounded-lg flex items-center justify-center">
                <Home className="w-5 h-5 text-earth-brown" />
              </div>
              <span className="text-lg font-serif font-semibold">Villa Dinoos</span>
            </div>
            <p className="text-sm text-earth-beige/80">
              Experience the comfort of home in luxurious surroundings, nestled in nature's embrace.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-earth-beige/80 hover:text-earth-beige transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/villa" className="text-sm text-earth-beige/80 hover:text-earth-beige transition-colors">
                  The Villa
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-sm text-earth-beige/80 hover:text-earth-beige transition-colors">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm text-earth-beige/80 hover:text-earth-beige transition-colors">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-sm text-earth-beige/80">
                <Phone className="w-4 h-4" />
                <span>+94 (777) 336-354</span>
                {/* <span>+94 (777) 336-766</span> */}
              </li>
              <li className="flex items-center space-x-2 text-sm text-earth-beige/80">
                <Mail className="w-4 h-4" />
                <span>dinoosluxuries@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-earth-beige/80">
                <MapPin className="w-4 h-4" />
                <span>152, Bandaranayake Lane, Weligama</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-earth-beige/80 hover:text-earth-beige transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-earth-beige/80 hover:text-earth-beige transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-earth-beige/80 hover:text-earth-beige transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-earth-beige/20 mt-8 pt-8 text-center">
          <p className="text-sm text-earth-beige/60">
            © 2025 Villa DINOOS. All rights reserved. | Privacy Policy | Terms of Service
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;